App.prototype.buildOrderInput = function (data, targetElement) {
    var options = '<option value="">' + translates.choose + '</option>';

    var required = data.is_required ? ' required' : '';

    var select = '<div class="form-group">' +
        '<label>' + data.name + '</label>' +
        '<input type="text" name="order_inputs[' + data.unique_id + ']" class="form-control" ' + required + '/>' +
        '</div>';
    targetElement.append(select);
};
